import {Sha1} from "@colibrio/colibrio-reader-framework/colibrio-core-encryption";

export class SimpleObfuscation {
    /**
     * @return hash (SHA-1) of the text as a hex string
     */
    static async obfuscate(text: string): Promise<string> {
        const sha1 = new Sha1();
        sha1.append(text);
        return sha1.digestToHex();
    }
}